import { useQuery } from "react-query"
import { get_listing_languages } from "../../services/jobs";


const useListingLanguages = (id) => {
    return useQuery(['get_listing_languages', id], () => get_listing_languages(id))
}

export default useListingLanguages;